import { ITracksId } from '@/interface';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
 
} from 'firebase/firestore';
import { db } from './firebase';

export const getAllFavorites = async () => {
  const groups = collection(db, 'favorites');
  return getDocs(groups);
};

export const saveFavorites = async (
  userId: string | undefined,
  payload: ITracksId[]
) => {
  if (!userId) return;
  const favorites = collection(db, 'favorites');
  return setDoc(doc(favorites, userId), {
    userId,
    groupId: userId,
    items: payload
  });
};

export const updateFavorites = async (
  userId: string | undefined,
  payload: ITracksId[],
  groupId: string | undefined
) => {
  if (!userId) return;
  if (!groupId) return;
  const group = doc(db, 'favorites', groupId);
  return updateDoc(group, {
    userId,
    groupId,
    items: payload
  });
};

export const getFavoritesById = async (userId: string) => {
  // const collectionsRef = collection(db, 'favorites')
  // const queryUser = query(collectionsRef, where('user', '==', userId))
  // // const unsubscribe = onSnapshot(queryUser, (snapshot: any) => {
  // //   return snapshot.docs.map((doc: any) => doc.data())
  // // })

  const docRef = doc(db, 'favorites', userId);
  const docSnap = await getDoc(docRef);

  return docSnap.exists() ? docSnap.data() : [];
  // }

  //   return unsubscribe
};
